module.exports = __webpack_public_path__ + "img/table-remove-button.06d14705.svg";